import i18n from "i18next";
import { type FC } from "react";
import { useCallback } from "react";
import { useNavigate } from "react-router";

import type { ProductEntity } from "src/app/features/Product/types/ProductEntity";
import { SecondaryButton } from "../../../../../components/Buttons/components/ActionButton";
import type { ButtonProps } from "../../../../../components/FeatureButtons/types";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../../core/router/types/routerTypes";
import { ProductType } from "../../types/ProductTypeEnum";

export const ProductFormCopyButton: FC<ButtonProps<ProductEntity>> = ({ item, items }) => {
    const navigate = useNavigate();

    const callback = useCallback(() => {
        const isProduct = item?.itemType === ProductType.product;

        const route = isProduct
            ? `${BASE_PATH}/${ResourceName.PRODUCTS}/${ProductType.product}/${FORM_ACTION.COPY}/${item?.id}`
            : `${BASE_PATH}/${ResourceName.PRODUCTS}/${ProductType.productCategory}/${FORM_ACTION.COPY}/${item?.id}`;

        navigate(route);
    }, [item, navigate]);

    const isDisabled = items?.length !== 1;

    return (
        <SecondaryButton name="ProductFormCopyButton" disabled={isDisabled} onClick={callback}>
            {i18n.t("button.copy")}
        </SecondaryButton>
    );
};
